import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { LDateTime } from '../../../../../../../components/date/LDateTime';

export function UnverifiedMatchesTable({
  data,
}: {
  data: auditReports.ReportMatchResultDto[];
}) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        {
          id: 'datetime',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.unverifiedMatches.datetime',
            defaultMessage: 'Fecha y hora',
          }),
          accessorFn: (row) => (row.datetime ? new Date(row.datetime) : null),
          Cell: ({ row }) => <LDateTime value={row.original.datetime} showSeconds />,
          enableSorting: true,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 100,
        },
        {
          id: 'customId',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.unverifiedMatches.customId',
            defaultMessage: 'Custom ID',
          }),
          accessorKey: 'customId',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
          size: 150,
        },
        {
          id: 'matchedSchedule',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.verified.matchedSchedule',
            defaultMessage: 'Schedule',
          }),
          accessorFn: (row) => row.matchedSchedule?.datetime || null,
          Cell: ({ row }) => {
            const matchedSchedule = row.original.matchedSchedule;
            if (matchedSchedule?.datetime) {
              return (
                <Chip
                  label={<LDateTime value={matchedSchedule.datetime} />}
                  size="small"
                  color="success"
                />
              );
            }
            return (
              <Chip
                label={$t({
                  id: 'audit.reportsScreen.ltxMatches.noSchedule',
                  defaultMessage: 'Sin schedule',
                })}
                size="small"
                color="warning"
              />
            );
          },
          enableSorting: true,
          enableColumnFilter: false,
        },
      ]}
    />
  );
}
